import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import useProductDetails from 'modules/products/hooks/use-product-details';
import {SizeProps} from 'modules/products/types';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import productsKeys from 'modules/products/util/products-keys';
import toBrl from 'shared/util/to-brl';

const Sizes: React.FC = () => {
  const {id} = useParams();
  const {data, isLoading} = useProductDetails(id!);
  const navigate = useNavigate();

  return (
    <Table<SizeProps>
      loading={isLoading}
      data={data?.sizes ?? []}
      options={[
        'name',
        {value: 'price', column: (row) => toBrl(row.price)},
        {
          value: 'id',
          label: 'Ações',
          column: (row) => (
            <QueryDeleteButton
              url={`/products/${id!}/sizes/${row.id}`}
              queryKey={productsKeys.details(id!)}
            />
          ),
        },
      ]}
      translatedPropsKey="SizeProps"
      onRowClick={(row) => navigate(row.id)}
    />
  );
};

export default Sizes;
